import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
  isActive?: boolean;
}

const AccountSettingIcon: React.FC<IconProps> = ({
  width = 12,
  height = 14,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 7.33333C7.59733 7.33333 9.05 7.796 10.1187 8.448C10.652 8.77333 11.108 9.15733 11.4373 9.57467C11.7613 9.98467 12 10.4753 12 11C12 11.5633 11.726 12.0073 11.3313 12.324C10.958 12.624 10.4653 12.8227 9.942 12.9613C8.89 13.2393 7.486 13.3333 6 13.3333C4.514 13.3333 3.11 13.24 2.058 12.9613C1.53467 12.8227 1.042 12.624 0.668667 12.324C0.273333 12.0067 0 11.5633 0 11C0 10.4753 0.238667 9.98467 0.562667 9.574C0.892 9.15733 1.34733 8.774 1.88133 8.44733C2.95 7.79667 4.40333 7.33333 6 7.33333ZM6 8.66667C4.65133 8.66667 3.438 9.06 2.576 9.586C2.14467 9.84867 1.81933 10.134 1.60933 10.4007C1.39333 10.674 1.33333 10.8807 1.33333 11C1.33333 11.0813 1.358 11.1673 1.50333 11.284C1.66933 11.4173 1.958 11.5553 2.39933 11.672C3.278 11.9053 4.54067 12 6 12C7.46 12 8.722 11.9047 9.6 11.672C10.042 11.5553 10.3307 11.4173 10.4967 11.284C10.642 11.1673 10.6667 11.0813 10.6667 11C10.6667 10.88 10.6067 10.674 10.3913 10.4007C10.1807 10.134 9.85533 9.84867 9.424 9.586C8.562 9.05933 7.34867 8.66667 6 8.66667ZM6 0C6.88406 0 7.7319 0.351189 8.35702 0.976311C8.98214 1.60143 9.33333 2.44928 9.33333 3.33333C9.33333 4.21739 8.98214 5.06523 8.35702 5.69036C7.7319 6.31548 6.88406 6.66667 6 6.66667C5.11595 6.66667 4.2681 6.31548 3.64298 5.69036C3.01786 5.06523 2.66667 4.21739 2.66667 3.33333C2.66667 2.44928 3.01786 1.60143 3.64298 0.976311C4.2681 0.351189 5.11595 0 6 0ZM6 1.33333C5.73736 1.33333 5.47728 1.38506 5.23463 1.48557C4.99198 1.58608 4.7715 1.7334 4.58579 1.91912C4.40007 2.10484 4.25275 2.32532 4.15224 2.56797C4.05173 2.81062 4 3.07069 4 3.33333C4 3.59598 4.05173 3.85605 4.15224 4.0987C4.25275 4.34135 4.40007 4.56183 4.58579 4.74755C4.7715 4.93326 4.99198 5.08058 5.23463 5.18109C5.47728 5.2816 5.73736 5.33333 6 5.33333C6.53043 5.33333 7.03914 5.12262 7.41421 4.74755C7.78929 4.37247 8 3.86377 8 3.33333C8 2.8029 7.78929 2.29419 7.41421 1.91912C7.03914 1.54405 6.53043 1.33333 6 1.33333Z"
        fill="#6E5E83"
      />
    </svg>
  );
};

export default AccountSettingIcon;
